const theme = {
    colors: {
        primary: "#9f1717",
        secondary: "#5c0e0e",
        accent: "#b28b47",
        background: "#f0f2f5",
        card: "#ffffff",
        text: "#000000",
    },
};

export default theme;
